export default __webpack_public_path__ + "static/orbit-big-purple.url-6107b1f5f95c5f4946bee8eaa818e02a.svg";